import classNames from "classnames";
import CiroButton from "../../shared/CiroButton";
import { useState } from "react";
import FilterIcon from "../../../assets/img/icons/FilterIcon";
import CiroFilterModalContainer from "../../shared/CiroFilter/CiroFilterModalContainer";
import CiroFilterSectionContactListFilters from "./CiroFilterSectionContactListFilters";
import { IAutopilotContactDetailsFilters } from "../../../reactHooks/filters/contactList/useAutopilotUrlQueryParams";

const AutopilotListFilterButton = ({
  resetAll,
  numFiltersApplied,
  filters,
  scoringCriteria,
  isCiroEnterprise,
}: {
  resetAll: () => void;
  numFiltersApplied: number;
  filters: IAutopilotContactDetailsFilters;
  scoringCriteria?: { id: number; label: string }[];
  isCiroEnterprise?: boolean;
}) => {
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const filterLabel = `Filters${Boolean(numFiltersApplied) ? ` (${numFiltersApplied})` : ""}`;

  const handleClick = () => setIsFilterModalOpen(!isFilterModalOpen);

  return (
    <>
      {/* Small screen button (icon only with tooltip) - hidden on xl screens */}
      <div className={classNames("xl:hidden")}>
        <CiroButton
          onClick={handleClick}
          analyticsField={`Open Ciro filters for Automation List (Small)`}
          customPaddingY="py-4"
          tooltip={filterLabel}
        >
          <span
            className={classNames(
              "whitespace-nowrap",
              "flex",
              "items-center",
              "font-medium",
            )}
          >
            <FilterIcon />
            <span className="ml-1">
              {Boolean(numFiltersApplied) && numFiltersApplied}
            </span>
          </span>
        </CiroButton>
      </div>

      {/* Large screen button (icon + text) - hidden on smaller screens */}
      <div className={classNames("hidden", "xl:block")}>
        <CiroButton
          onClick={handleClick}
          analyticsField="Open Ciro filters for Automation List (Large)"
          customPaddingY="py-3"
        >
          <span
            className={classNames(
              "whitespace-nowrap",
              "flex",
              "items-center",
              "font-medium",
            )}
          >
            <span className="mr-2">
              <FilterIcon />
            </span>
            <span>{filterLabel}</span>
          </span>
        </CiroButton>
      </div>

      <CiroFilterModalContainer
        displayCTA={false}
        resetAll={resetAll}
        numFiltersApplied={numFiltersApplied}
        filtersSection={[
          <CiroFilterSectionContactListFilters
            key={1}
            filters={filters}
            scoringCriteria={scoringCriteria}
            isCiroEnterprise={isCiroEnterprise}
          />,
        ]}
        isLoading={false}
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        subtitle={"Apply filters to your search"}
      />
    </>
  );
};

export default AutopilotListFilterButton;
